// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const glalie_mega: PokeData = {
  "id": 10074,
  "name": "glalie-mega",
  "height": 21,
  "weight": 3502,
  "base_experience": 203,
  "types": [
    PokeType.ICE
  ],
  "api_moves": [
    "headbutt",
    "leer",
    "bite",
    "blizzard",
    "double-team",
    "powder-snow",
    "protect",
    "icy-wind",
    "crunch",
    "hail",
    "sheer-cold",
    "ice-shard",
    "ice-fang",
    "frost-breath",
    "freeze-dry"
  ],
  "moves": [
    "headbutt",
    "leer",
    "bite",
    "blizzard",
    "protect",
    "crunch",
    "sheer-cold",
    "ice-shard",
    "ice-fang",
    "ice-punch",
    "hailstorm",
    "ice-wave",
    "icicle-dagger"
  ],
  "evolution_chain": {
    "id": 186,
    "item": null,
    "species": [
      {
        "name": "snorunt",
        "order": 390,
        "types": [
          PokeType.ICE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "glalie",
        "order": 391,
        "types": [
          PokeType.ICE
        ],
        "evolves_from_species_id": 361,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 42,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "froslass",
        "order": 392,
        "types": [
          PokeType.ICE,
          PokeType.GHOST
        ],
        "evolves_from_species_id": 361,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "dawn-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": {
              "name": "female"
            }
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 107,
    "speed": 133,
    "ability_power": 160
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": true,
  "is_gmax": false,
  "regional_variant": null
} as const;
